import {
  doMoveFieldIntoRow,
  doProcessNewControl,
  doReorderPageElements,
  doProcessNewRowControl,
  doMoveFieldInRowToPage,
  doMoveFieldFromRowToRow,
  validatePaymentFieldAddition
} from './element';

import { createControlForType, planSupportField } from '../../../shared/form-lib';
import { doShowUpgradePlanModal } from '../reducers/builder';

export const doDragElementEnd = (result) => async (dispatch) => {
  const { destination, source, draggableId } = result;

  if (!destination) {
    return;
  }

  if (
    (destination.droppableId === source.droppableId && destination.index === source.index) ||
    destination.droppableId.includes('sidebar') ||
    (destination.droppableId.includes('row-field') && destination.droppableId.split(' ')[0] === draggableId)
  ) {
    return;
  }

  // If control is dragged from the sidebar
  if (source.droppableId.includes('sidebar')) {
    const newControl = {};
    const control = createControlForType(draggableId);
    newControl.props = control;
    newControl.type = draggableId;

    if (planSupportField(draggableId)) {
      const canCreate = await dispatch(validatePaymentFieldAddition(draggableId))
      if (!canCreate) return;

      if (destination.droppableId.includes('row-field')) {
        const rowInternalId = destination.droppableId.split(' ')[0];
        if (draggableId === 'embed_field') newControl.props.height = 165;
        dispatch(doProcessNewRowControl(newControl, result, rowInternalId));
      } else {
        if (draggableId === 'embed_field') newControl.props.height = 480;
        dispatch(doProcessNewControl(newControl, result));
      }
    } else dispatch(doShowUpgradePlanModal(true));
  }

  // If control field is dragged
  if (source.droppableId === 'controls-list') {
    if (destination.droppableId.includes('row-field')) {
      const rowInternalId = destination.droppableId.split(' ')[0];
      dispatch(doMoveFieldIntoRow(result, rowInternalId));
    } else {
      dispatch(doReorderPageElements(result));
    }
  }

  // If field in a row is dragged out of row
  if (source.droppableId.includes('row-field')) {
    if (destination.droppableId === 'controls-list') {
      const rowInternalId = source.droppableId.split(' ')[0];
      dispatch(doMoveFieldInRowToPage(result, rowInternalId));
    }
    if (destination.droppableId.includes('row-field')) {
      const destRowInternalId = destination.droppableId.split(' ')[0];
      const sourceRowInternalId = source.droppableId.split(' ')[0];
      dispatch(doMoveFieldFromRowToRow(result, destRowInternalId, sourceRowInternalId));
    }
  }
};

export default doDragElementEnd;
